import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = {
  key: 0,
  class: "titlebar-text"
}
const _hoisted_6 = {
  key: 1,
  style: {"font-size":"16px"},
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Oficio:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Data:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1)
const _hoisted_10 = { class: "titlebar-actions" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_12 = { class: "titlebar-actions-primary" }
const _hoisted_13 = {
  key: 0,
  class: "ui-button",
  type: "button"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Atualizar Status")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "ui-button-content" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "ui-card" }
const _hoisted_20 = { class: "ui-card-body" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_combo_usuario = _resolveComponent("combo-usuario")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_card = _resolveComponent("card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.oficio.codigo === 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.state.oficio.numero) + " ", 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(_ctx.state.oficio.data)) + " ", 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.servicoOficio.obterNomeStatus(_ctx.state.oficio.status)), 1)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_popover, {
            trigger: ['hover','click'],
            placement: "bottom"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                size: "small",
                style: {"min-width":"180px"}
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.oficio.status !== _ctx.EStatusOficio.EmDigitacao))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        block: "",
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.atualizarStatus(_ctx.EStatusOficio.EmDigitacao)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Em Digitação ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.state.oficio.status !== _ctx.EStatusOficio.Autorizado))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        block: "",
                        size: "small",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.atualizarStatus(_ctx.EStatusOficio.Autorizado)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Autorizado ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_popconfirm, {
                    title: "Excluir este oficio?",
                    "ok-text": "Sim",
                    "cancel-text": "Não",
                    onConfirm: _cache[2] || (_cache[2] = () => _ctx.atualizarStatus(_ctx.EStatusOficio.Excluido))
                  }, {
                    default: _withCtx(() => [
                      ((_ctx.state.oficio.status !== _ctx.EStatusOficio.Excluido))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            block: "",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Excluído ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              ((_ctx.state.oficio.codigo > 0 && !_ctx.state.gerandoPdf))
                ? (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.state.gerarPdf)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                class: "ui-button",
                loading: _ctx.state.gerandoPdf,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gerarPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.state.gerandoPdf? 'Aguarde por favor... Estamos gerando o seu PDF': 'Gerar PDF'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.state.gerandoPdf)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.salvar()))
              }, _hoisted_18))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Responsável pelo Registro" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_usuario, {
                          codigo: _ctx.state.oficio.codigoUsuarioRegistro,
                          "onUpdate:codigo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.oficio.codigoUsuarioRegistro) = $event)),
                          disabled: true
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, { label: "Data Ofício" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.oficio.dataOficio,
                          "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.oficio.dataOficio) = $event))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, { titulo: "INFORMAÇÕES" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_form_item, { label: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_editor_html, {
                              value: _ctx.state.oficio.conteudo,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.oficio.conteudo) = $event)),
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.marcarAlterado()))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}